<template>
  <div>
    <PaymentOption :initial_value="payment" />
    <div class="div-block-45">
      <CheckBox :initial_value="agree" @isChecked="setCheckbox" />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue"

import ChooseCity from "@/components/ChooseCity.vue"
import PaymentOption from "@/components/PaymentOption.vue"
import CheckBox from "@/elements/CheckBox.vue"

export default {
  components: {
    Header,
    ChooseCity,
    CheckBox,
    PaymentOption,
  },
  props: [],
  created() {
    this.$store.state.page.index = 3
  },
  data: () => {
    return {}
  },
  methods: {
    setCheckbox(value) {
      this.$store.state.payment_info.agree = value
    },
  },

  computed: {
    payment: function () {
      return this.$store.state.payment_info.payment_option
    },
    agree: function () {
      return this.$store.state.payment_info.agree
    },
  },
}
</script>
